import { Component, Input } from '@angular/core';

import { ICustomDeliveryTime } from '../../../cart';

@Component({
  standalone: false,
  selector: 'custom-delivery-times',
  styles: [`
    .custom-time-wrap + .custom-time-wrap {
      margin-top: .6rem;
    }

    .custom-delivery-day {
      width: 166px;
    }
  `],
  template: `
    <div class="font-sm">
      <div class="fw-bold mb-2" [translate]="'orderProcess.delivery.deliveryForms.specialDeliveryTimes'">
        Special delivery times
      </div>

      <div *ngFor="let customDay of deliveryScheduleOverrides" class="d-flex flex-nowrap custom-time-wrap">
        <div class="custom-delivery-day">
          {{ customDay.dateBegin === customDay.dateEnd ? customDay.dateBegin : customDay.dateBegin + ' - ' + customDay.dateEnd }}
        </div>

        <div class="ps-4">
          <span *ngIf="customDay.isClosed; else deliveryTime"
                [translate]="'common.dayOff'">
            Closed
          </span>

          <ng-template #deliveryTime>
            {{ customDay.openingHoursStart | stringifyMinutes : 'HH:mm' }}
            -
            {{ customDay.openingHoursEnd | stringifyMinutes : 'HH:mm' }}

            <strong class="ps-3">{{ customDay.price | currencyFormat: currencySymbol }}</strong>
          </ng-template>
        </div>
      </div>
    </div>
  `,
})
export class CustomDeliveryTimesComponent {
  @Input() deliveryScheduleOverrides: ICustomDeliveryTime[];
  @Input() currencySymbol: string;
}
